import React from 'react'
import PropTypes from 'prop-types'

import SimpleHeader from './../block/SimpleHeader'
import Footer from './../block/Footer'

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { data, user, showFeedbackForm, cart, leftMenu, parent } = this.props

    return (
      <div className='container bg-[#F6F6F6] font-manrope tracking-tight'>
        <SimpleHeader
          title={data?.pagetitle}
          user={user}
          lk_link={data?.lk_link}
        />
        <div className='mt-[8px] mb-[150px] bg-white rounded-[25px] p-[10px] py-[20px] min-h-[200px]'>
          <div className={`editor-content ${parent == 260 ? `akciya-editor` : ``}`} dangerouslySetInnerHTML={{__html: data?.content}} />
        </div>
        <Footer
          showFeedbackForm={showFeedbackForm}
          data={data}
          cart={cart}
          leftMenu={leftMenu}
        />
      </div>
    )
  }
}

Main.propTypes = {
  data: PropTypes.object,
  user: PropTypes.object,
  showFeedbackForm: PropTypes.func,
  cart: PropTypes.object,
  leftMenu: PropTypes.func,
  parent: PropTypes.number
}

export default Main